import { Link } from 'react-router';
import { getAdminCatalogProductDetailPath } from '../adminRoutes';
import { useCatalogCategoryProducts } from './useCatalogRelatedLists';
import { CatalogPagination } from './CatalogPagination';
import { CatalogRequestState } from './CatalogRequestState';

export function CatalogCategoryProducts({ categoryId }: { categoryId: number }) {
  const { query, page, setPage, search, setSearch } = useCatalogCategoryProducts(categoryId);
  return (
    <section className="catalog-content-section" aria-labelledby="category-products-title">
      <header className="catalog-section-heading">
        <div>
          <h2 id="category-products-title">Товары категории {query.data?.meta.total !== undefined ? <span>{query.data.meta.total}</span> : null}</h2>
          <p>Товары, привязанные непосредственно к этой категории.</p>
        </div>
        <label className="catalog-search">
          <span className="catalog-visually-hidden">Поиск товаров категории</span>
          <input type="search" placeholder="Название или артикул" value={search} onChange={(event) => setSearch(event.target.value)} />
        </label>
      </header>
      {query.isPending || query.isError ? (
        <CatalogRequestState error={query.error?.message} onRetry={() => { void query.refetch(); }} />
      ) : query.data.items.length === 0 ? (
        <div className="catalog-empty">
          <h3>{search ? 'Товары не найдены' : 'В этой категории пока нет товаров'}</h3>
          <p>{search ? 'Попробуйте другое название или очистите поиск.' : 'Выберите эту категорию в карточке товара, чтобы добавить его сюда.'}</p>
          {search ? <button className="catalog-button" type="button" onClick={() => setSearch('')}>Очистить поиск</button> : null}
        </div>
      ) : (
        <>
          <ul className="catalog-linked-products">
            {query.data.items.map((product) => (
              <li key={product.product_id}>
                <Link to={getAdminCatalogProductDetailPath(product.product_id)}>
                  <span><strong>{product.product_name}</strong><small>{product.product_sku}</small></span>
                  <span>{product.product_unit_name || '—'} <span aria-hidden="true">→</span></span>
                </Link>
              </li>
            ))}
          </ul>
          <CatalogPagination page={page} pageCount={query.data.meta.page_count ?? 1} onChange={setPage} />
        </>
      )}
    </section>
  );
}
